// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/uploader/api/uploader.proto (package gx.uploader.api, syntax proto3)
/* eslint-disable */

import { UploadService } from "./uploader_pb.js";

/**
 * Sync Management
 *
 * @generated from rpc gx.uploader.api.UploadService.CreateUploadSync
 */
export const createUploadSync = UploadService.method.createUploadSync;

/**
 * @generated from rpc gx.uploader.api.UploadService.GetUploadSync
 */
export const getUploadSync = UploadService.method.getUploadSync;

/**
 * @generated from rpc gx.uploader.api.UploadService.CancelUploadSync
 */
export const cancelUploadSync = UploadService.method.cancelUploadSync;

/**
 * Initiates upload and returns presigned URLs
 *
 * @generated from rpc gx.uploader.api.UploadService.InitiateUpload
 */
export const initiateUpload = UploadService.method.initiateUpload;

/**
 * For refreshing expired presigned URLs in case of a resume after long duration
 *
 * @generated from rpc gx.uploader.api.UploadService.RefreshPresignedUrls
 */
export const refreshPresignedUrls = UploadService.method.refreshPresignedUrls;

/**
 * Called after each part is uploaded to S3
 *
 * @generated from rpc gx.uploader.api.UploadService.CompletePartUpload
 */
export const completePartUpload = UploadService.method.completePartUpload;

/**
 * Completes multipart upload with ETags
 *
 * @generated from rpc gx.uploader.api.UploadService.CompleteOperationUpload
 */
export const completeOperationUpload = UploadService.method.completeOperationUpload;

/**
 * Abort an operation upload (cleanup S3 multipart upload)
 *
 * @generated from rpc gx.uploader.api.UploadService.AbortOperationUpload
 */
export const abortOperationUpload = UploadService.method.abortOperationUpload;
